import { useEffect, useState } from "react";
import { useSchoolParentApi } from "../../../utils/useSchoolParentApi";

const useStudentProgressInfo = (studentId, questId) => {
  const [kidDetail, setKidDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const apiUrl = process.env.REACT_APP_API_URL;
  const { apiCall } = useSchoolParentApi();

  useEffect(() => {
    if (!studentId || !questId) return;

    const fetchProgress = async () => {
      setLoading(true);
      setError(null);

      try {
        const data = await apiCall(
          `${apiUrl}/parent/student/progress/${studentId}/${questId}`,
          { method: "GET" },
        );

        setKidDetail(data);
      } catch (err) {
        setError(
          err?.response?.data?.message ||
            err?.message ||
            "Failed to fetch student progress",
        );
      } finally {
        setLoading(false);
      }
    };

    fetchProgress();
  }, [studentId, questId, apiUrl]);

  return { kidDetail, loading, error };
};

export default useStudentProgressInfo;
